"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _GridColumnFlex = _interopRequireDefault(require("../../GridColumnFlex"));

var _Image = _interopRequireDefault(require("../../../atoms/Image"));

var _proptypes = require("../../../services/proptypes");

var propTypes = {
  background: _propTypes["default"].bool,
  children: _proptypes.ChildrenPropType,
  width: _propTypes["default"].string
};
var defaultProps = {
  background: false,
  children: null,
  width: null
};

function Image(_ref) {
  var background = _ref.background,
      children = _ref.children,
      width = _ref.width,
      imageProps = (0, _objectWithoutProperties2["default"])(_ref, ["background", "children", "width"]);
  var isBackground = !!(children && children.length) || background;

  if (isBackground) {
    return /*#__PURE__*/_react["default"].createElement(_Image["default"], (0, _extends2["default"])({}, imageProps, {
      background: true,
      as: _GridColumnFlex["default"],
      width: width
    }), children);
  }

  return /*#__PURE__*/_react["default"].createElement(_GridColumnFlex["default"], {
    className: "image-component",
    width: width
  }, /*#__PURE__*/_react["default"].createElement(_Image["default"], imageProps));
}

Image.propTypes = propTypes;
Image.defaultProps = defaultProps;
var _default = Image;
exports["default"] = _default;